<template>
  <div :style="{ background: '#FFFFFF', height: '100vh' }">
    <OnboardingLayout
      title="Start your Arnergy Journey!"
      description="Join thousands of Arnergy users all over Africa who are enjoying uninterrupted power supply with our solar solution."
      :disableBackButton="true"
      :imageDescription="welcomeText"
      @onButtonClick="handleContinue"
      :canContinue="canContinue"
    >
      <div class="choose-package">
        <div class="boxes customer-type">
          <div v-for="item in customerType" :key="item.id">
            <!-- <onboarding-select-button
              :title="item.title"
              :description="item.description"
              :isActive="activeCustomerType && activeCustomerType.id == item.id"
              :image="null"
              @setActive="updateCustomerType(item)"
            /> -->
            <div
              @click="updateCustomerType(item)"
              @mouseover="onMouseOver(item)"
              :class="
                (activeCustomerType && activeCustomerType.id) == item.id
                  ? 'flex-row active'
                  : 'flex-row'
              "
            >
              <div
                class="pix-container"
                :style="
                  `background-image: url(${item.image}); background-position: center top; background-size: cover; background-repeat: no-repeat;`
                "
              ></div>
              <div class="content-container">
                <h3>Zero Down Payment</h3>
                <p>Start your Solar journey with no upfront cost.</p>
                <!-- <h3>{{ item.title }}</h3>
                <p>{{ item.description }}</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </OnboardingLayout>
  </div>
</template>

<script>
/* eslint-disable */
import ButtonOnboardingPackage from "@/components/pages/kitchen/ButtonOnboardingPackage";
import ModalCalculate from "@/components/pages/kitchen/Onboarding/ModalCalculate";
import ModalMain from "@/components/pages/kitchen/Onboarding/ModalMain.vue";
import SideIndicator from "@/components/pages/kitchen/Onboarding/SideIndicator.vue";
import OnboardingSelectButton from "@/components/pages/kitchen/OnboardingSelectButton";
import MoneyFormat from "vue-money-format";
import { mapActions, mapGetters } from "vuex";

import OnboardingButton from "@/components/OnboardingButton.vue";
import OnboardingTopBar from "@/components/OnboardingTopBar.vue";
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import OnboardingService from "@/services/onboarding.js";

export default {
  name: "Onboarding",
  computed: {
    ...mapGetters(["getUserSession"]),
    filteredPaymentTypes() {
      return this.paymentTypes.filter(item => item.key !== "OS");
    }
  },
  components: {
    OnboardingLayout,
    ButtonOnboardingPackage,
    OnboardingSelectButton,
    SideIndicator,
    ModalCalculate,
    ModalMain,
    MoneyFormat,
    OnboardingTopBar,
    OnboardingButton
  },
  data() {
    return {
      showLoading: false,
      canContinue: false,
      customerType: [
        {
          id: 0,
          key: "IPP",
          title: "IPP Customer",
          image:
            "https://media.istockphoto.com/id/170617464/photo/suburban-houses.jpg?s=612x612&w=0&k=20&c=r6ltRfFundG_3oet68ZkuwdIhbxy1IA_yLtjIusEx7g=",
          description: "Enjoy cost savings and peace of mind from day one"
        }
        // {
        //   id: 1,
        //   key: "Standard",
        //   title: "Standard Customer",
        //   image:
        //     "https://png.pngtree.com/png-vector/20240129/ourlarge/pngtree-3d-illustration-of-a-house-with-solar-panels-png-image_11565248.png",
        //   description:
        //     "These are customers who don’t currently stay in multi-unit prequalified gated estates and don’t pay for electricity through a tarrif system to an estate management."
        // }
      ],
      activePackageType: {},
      activeCustomerType: {},
      activePaymentType: {},
      welcomeText: "Welcome",
      paymentTypes: [
        {
          id: 0,
          key: "LO",
          title: "Lease to Own (LO)",
          description:
            "This allows you to pay monthly over a specified lease tenor and own the system afterward"
        },
        {
          id: 1,
          key: "OS",
          title: "Outright Sale (OS)",
          description:
            "This allows you to pay once and the package becomes yours forever"
        }
      ]
    };
  },
  methods: {
    onMouseOver(item) {
      // console.log(this.activeCustomerType);
      this.welcomeText = item.description;
    },
    updateCustomerType(item) {
      this.activeCustomerType = item;
      this.welcomeText = item.description;
      this.canContinue = true;
    },
    updateGlobalState() {
      OnboardingService.updateDbData({
        // currentPageName: this.nextPageName,
        packagetype: "ipp"
      });
      const onboardingCustomerState = this.$store.state.onboardingCustomerState;
      this.$store.commit("saveOnboardingCustomerState", {
        ...onboardingCustomerState,
        paymentType: "ipp"
      });
    },
    async updateStatus() {
      const HTTP = this.$httpUtils.FASTHTTP;
      const payloadData = {
        currentPageName: "Start"
      };

      HTTP.patch("/onboardingstate/nextstate", payloadData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("appUserToken")}`
        }
      })
        .then(
          res => console.log(res)
          // this.$store.commit("saveOnboardingCustomerState", res.data)
        )
        .catch(error => console.log({ error }));
    },
    handleContinue() {
      if (this.activeCustomerType.title == "IPP Customer") {
        this.updateGlobalState();
        // this.navTo("OnboardIPP");
        this.navTo("OnboardLocationSelection");
      } else if (this.activeCustomerType.title == "Standard Customer") {
        this.navTo("OnboardStandard");
      } else {
        return;
      }
    }
  },
  async mounted() {
    await this.updateStatus();
  }
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  width: 100%;
  padding: 0rem 14rem;
  font-family: "DM Sans";
  background: #ffffff;

  @media screen and (max-width: 600px) {
    padding: 0rem 2rem;
    flex-direction: column-reverse;
  }
}

.choose-package {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.button {
  border: 1px solid #0892d0;
  border-radius: 5px;
  padding: 7px 10px;
}

.welcome {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
  color: #0892d0;
  margin-bottom: 2.1rem;
}

.subtext {
  font-family: "DM Sans";
  max-width: 58.1rem;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #727272;
  margin-bottom: 2.7rem;
}

.choice-type {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 2.7rem;
  color: #fe7a11;
}

.boxes {
  display: flex;
  margin-bottom: 2.7rem;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.package {
  display: flex;
  margin-bottom: 2.7rem;
  margin-top: 5rem;

  & div {
    div {
      height: 27rem;
    }
  }
}

.customer-type {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .active {
    border: 3px solid #0892d0;
  }
}

.right-image {
  display: flex;
  flex-direction: column;
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.man-woman {
  margin-bottom: 9rem;
}

.continue {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}

.flex-row {
  display: flex;
  // align-items: center;
  border-radius: 10px;
  width: 100%;
  min-height: 200px;
  border: 0.5px solid grey;
  // max-width: 600px;

  h3 {
    color: #0892d0;
    font-weight: bold;
  }

  p {
    color: black;
  }

  &:hover {
    background-color: #0892d0;
    color: white;
    cursor: pointer;
    box-shadow: 1px 1px 3px grey;

    p,
    h3 {
      color: white;
    }
  }
}

.pix-container {
  width: 200px;
  min-height: 200px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.content-container {
  display: flex;
  flex-direction: column;
  width: 450px;
  padding: 20px;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 768px) {
  .content-container {
    width: 300px;
  }
}

@media only screen and (max-width: 600px) {
  .flex-row {
    flex-direction: column !important;
  }

  .content-container {
    width: 100%;
  }

  .pix-container {
    width: 100%;
    border-bottom-left-radius: 0;
    border-top-right-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/index.vue